import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { NumberInput, SaveButton } from 'react-admin';
import DateTimeInputUTC from '../../components/DateTimeInputUTC';
import { DropDownPartners } from '../../components';
import moment from 'moment';
import { validRows } from '../../lib/validRows';

const imageWrapperSx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    height: 100,
    width: 120,
};

const rowSx = {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
    margin: '0 0 10px 0'
};

const selectWrapperSx = {
    width: 180,
    height: 120,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
};

const filterRowSx = {
    display: 'flex',
    alignItems: 'flex-end'
};

const filterWrapperSx = {
    margin: '0 15px 0 0',
};

const Filters = ({ children }) => {
    return (
        <Box sx={filterRowSx}>
            {React.Children.map(children, child =>
                <Box sx={filterWrapperSx}>
                    {child}
                </Box>
            )}
        </Box>
    )
}

export default ({
    products,
    origin,
    destination,
    saveCallback,
    places,
    originDeposit,
    destinationDeposit,
    setOriginPlaceCallback,
    setDestinationPlaceCallback,
    setOriginDeposit,
    setDestinationDeposit,
    loading,
    date,
    setDateCallback
}) => {
    const [transferredProducts, setTransferredProducts] = useState([]);
    const readyProducts = validRows(transferredProducts);

    const inputOnChange = ({ productId, value }) => {
        const transferredProductIndex = transferredProducts.findIndex((p) => p.productId === productId)
        if (transferredProductIndex === -1) {
            transferredProducts.push({ productId, value, stockType: originDeposit });
        } else {
            transferredProducts[transferredProductIndex].value = value;
        }
        setTransferredProducts([...transferredProducts]);
    }

    useEffect(() => {
        setTransferredProducts([])
    }, [origin, originDeposit])

    return (
        <>
            <Box sx={rowSx}>
                <Filters>
                    <Box sx={selectWrapperSx}>
                        <DropDownPartners
                            label="Unidade de origem"
                            value={origin}
                            setValue={setOriginPlaceCallback}
                            arrayData={places}
                            disabled={(loading)}
                        />
                        <DropDownPartners
                            label="Unidade de destino"
                            value={destination}
                            setValue={setDestinationPlaceCallback}
                            arrayData={places}
                            disabled={(loading)}
                        />
                    </Box>
                    <Box sx={selectWrapperSx}>
                        <DropDownPartners
                            label="Depósito de origem"
                            value={originDeposit}
                            setValue={setOriginDeposit}
                            arrayData={[{ id: 'warehouse', name: 'Depósito central' }, { id: 'showcase', name: 'Mostruário' }]}
                            disabled={(loading)}
                        />
                        <DropDownPartners
                            label="Depósito de destino"
                            value={destinationDeposit}
                            setValue={setDestinationDeposit}
                            arrayData={[{ id: 'warehouse', name: 'Depósito central' }, { id: 'showcase', name: 'Mostruário' }]}
                            disabled={(loading)}
                        />
                    </Box>
                    <DateTimeInputUTC
                        label='Data da transferência'
                        ampm={false}
                        name="date"
                        source="date"
                        disableFuture
                        parse={(value) => moment(value).toISOString()}
                        defaultValue={moment().startOf('day').toISOString()}
                        onChange={date => setDateCallback(date)}
                        sx={{ marginBottom: 0 }}
                        helperText={false}
                    />,
                </Filters>
                <SaveButton
                    disabled={(loading || readyProducts.length === 0)}
                    onClick={
                        () => {
                            saveCallback({ date: date.utc().toISOString(), transferredProducts: readyProducts })
                            setTransferredProducts([])
                        }}
                />
            </Box>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Produto</TableCell>
                            <TableCell align="center">Nome</TableCell>
                            <TableCell align="center">Quantidade Atual</TableCell>
                            <TableCell align="center">Quantidade Transferida</TableCell>
                            <TableCell align="center">Quantidade Final</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(products && products.length > 0) ?
                            products.map(row => {
                                const product = transferredProducts.find((p) => p.productId === row.id);
                                const originValue = row[originDeposit] ? +row[originDeposit] : 0;
                                const productValue = product ? +product.value : 0;

                                return (
                                    <TableRow key={row.id}>
                                        <TableCell align="center">
                                            {row.image_path ?
                                                <Box sx={imageWrapperSx}>
                                                    <img src={row.image_path} style={{ width: '100%' }} alt='Imagem do produto' />
                                                </Box>
                                                :
                                                <p>Imagem indisponível</p>
                                            }
                                        </TableCell>
                                        <TableCell align="center">{row.name}</TableCell>
                                        <TableCell align="center">{originValue}</TableCell>
                                        <TableCell align="center">
                                            <NumberInput
                                                label="Transferência"
                                                min={0}
                                                value={product ? product.value || "" : ""}
                                                variant="outlined"
                                                source={`trasnferredProduct-${row.id}`}
                                                onChange={event => inputOnChange({ value: event.target.value, productId: row.id })}
                                            />
                                        </TableCell>
                                        <TableCell align="center">
                                            {originValue - productValue}
                                        </TableCell>
                                    </TableRow>
                                )
                            })
                            :
                            <Typography>Nenhum produto no inventário</Typography>
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
}
